<template>
  <section class="relative overflow-hidden bg-grey-10 px-4 py-8 c-white lg:py-22 md:px-8">
    <base-picture v-if="image" v-bind="image" class="absolute-0 full" fit="cover" />
    <div class="absolute-0 bg-black bg-op-20" />
    <div class="relative mx-a md:p-6" style="max-width: 63.25rem">
      <h2 class="mx-a mb-8 text-center text-3xl fw-bold lh-none md:mb-12 md:ws-pre-wrap md:text-4xl <md:p-7">
        {{ heading }}
      </h2>
      <base-scroll class-container="gap-2 lg:grid lg:cols-3 lg:gap-3">
        <article
          v-for="{ benefitIntro, benefits, icon, spendThreshold, threshold, title } in tiersWithBenefits"
          :key="title"
          class="w-82 f-col items-start gap-6 b b-grey-60 b-op-20 rounded-md bg-black bg-op-30 px-6 pb-9 pt-6 backdrop-blur-lg lg:w-a"
          style="min-height: 28rem"
        >
          <base-picture v-if="icon" v-bind="icon" height="24" width="24" />
          <div class="w-full f-col gap-3">
            <h3 class="text-4xl fw-bold lh-none">
              {{ title }}
            </h3>
            <div class="f-col">
              <p class="text-md lh-5 font-secondary">
                {{ threshold }}
              </p>
              <p class="text-md lh-5 font-secondary">
                {{ spendThreshold }}
              </p>
            </div>
          </div>
          <hr class="w-full b-grey-50">
          <div class="w-full f-col gap-4">
            <p v-if="benefitIntro" class="text-base lh-tight">
              {{ benefitIntro }}
            </p>
            <ul class="text-base lh-tight space-y-3">
              <li v-for="benefit in benefits" :key="benefit" class="flex gap-2">
                <span class="mt-0.5 h-4 w-4 flex shrink-0 center rounded-full bg-brand-6">
                  <vf-icon class="c-black" name="check" size="xs" />
                </span>
                <span>{{ benefit }}</span>
              </li>
            </ul>
          </div>
        </article>
      </base-scroll>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { Responsive } from '#types/common'

const props = defineProps<{
  image?: {
    src: Responsive | string
    alt?: string
  }
  tiers: {
    title: string
    icon: {
      src: Responsive | string
      alt?: string
    }
    threshold: string
    spendThreshold: string
    benefitIntro?: string
    benefits: string[]
  }[]
  heading: string
}>()

const { $feature, $t } = useNuxtApp()
const tiersWithBenefits = computed(() => props.tiers.map((tier, index) => ({
  ...tier,
  benefits: index === 0
    ? [replaceAll($t.loyaltyProgrammeBasecampFirstOrderDiscount, {
        percent: $feature.configSignUp?.loyaltyRewardPercent
      }), ...tier.benefits]
    : tier.benefits
})))
</script>
